import React, { useEffect } from "react";
import { getToken } from "../cookie/Cookie";
import {
  deleteApiMethod,
  getApiMethod,
  postApiMethod,
  putApiMethod,
} from "./Global";
import { APICONSTANT } from "./Config";
import { clearDynamicData } from "../../components/ruralDetailsCount/store";
import { ToastNotifier } from "../../components/ui/ToastNotifier";

const containsScriptOrTags = (value) => {
  if (typeof value === "string") {
    // Normalize to lowercase for case-insensitive check
    const lowerValue = value.toLowerCase();

    // 🚫 Disallow <script>, <, >, {, } characters
    if (
      lowerValue.includes("<script") ||
      lowerValue.includes("</script>") ||
      lowerValue.includes("<") ||
      lowerValue.includes(">") ||
      lowerValue.includes("{") ||
      lowerValue.includes("}")
    ) {
      return true;
    }

    // 🚫 Disallow "javascript:" anywhere
    if (lowerValue.includes("javascript:")) {
      return true;
    }

    // 🚫 Disallow markdown-style [text](javascript:...)
    const mdJsLinkRegex = /\[.*?\]\(\s*javascript:.*?\)/i;
    if (mdJsLinkRegex.test(lowerValue)) {
      return true;
    }
  } else if (Array.isArray(value)) {
    return value.some((item) => containsScriptOrTags(item));
  } else if (typeof value === "object" && value !== null) {
    return Object.values(value).some((val) => containsScriptOrTags(val));
  }
  return false;
};

export const getFetchData = async (login, dispatch, apiUrl) => {
  try {
    const fetch = await getApiMethod(dispatch, {
      login,
      apiUrl,
    });

    if (fetch && fetch.status === 1) {
      return fetch;
    } else {
      console.warn("Fetch response status is not 1:", fetch);
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

export const postFetchData = async (login, dispatch, apiUrl, body, id) => {
  try {
    const fetch = await postApiMethod(dispatch, {
      login,
      apiUrl,
      body,
    });

    if (containsScriptOrTags(body)) {
      ToastNotifier(
        "Invalid input: contains disallowed tags or characters.",
        "error"
      );
      throw new Error();
    }

    if (fetch && fetch.status === 1) {
      return fetch;
    } else {
      console.warn("Post response status is not 1:", fetch);
      dispatch(clearDynamicData(id));

      return null;
    }
  } catch (error) {
    console.error("Error posting data:", error);
    return null;
  }
};

export const putFetchData = async (login, apiUrl, body) => {
  try {
    const fetch = await putApiMethod({
      login,
      apiUrl,
      body,
    });

    if (fetch && fetch.status === 1) {
      return fetch;
    } else {
      console.warn("Put response status is not 1:", fetch);
      return null;
    }
  } catch (error) {
    console.error("Error updating data:", error);
    return null;
  }
};

export const deleteFetchData = async (login, apiUrl, body) => {
  try {
    // const token = await getToken("token");
    const fetch = await deleteApiMethod({
      login,
      apiUrl,
      body,
    });

    if (fetch && fetch.status === 1) {
      return fetch;
    } else {
      console.warn("Delete response status is not 1:", fetch);
      return null;
    }
  } catch (error) {
    console.error("Error deleting data:", error);
    return null;
  }
};
